import { Component, OnInit } from '@angular/core';
import { RouterOutlet, Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { AuthService } from './services/auth.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, CommonModule],
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  title = 'user-web-app';
  isAuthInitialized = false;

  constructor(private authService: AuthService, private router: Router) {}

  ngOnInit(): void {
    console.log('App component initializing...');
    
    // Wait for auth initialization
    this.authService.user$.subscribe(user => {
      if (this.authService.isAuthInitialized && !this.isAuthInitialized) {
        this.isAuthInitialized = true;
        console.log('App: Auth initialized, user state:', user ? 'authenticated' : 'not authenticated');
        
        // Check current route and redirect appropriately
        const currentRoute = this.router.url;
        console.log('Current route:', currentRoute);
        
        // If user is authenticated and on login page, redirect to dashboard
        if (user && (currentRoute === '/login' || currentRoute === '/' || currentRoute === '')) {
          console.log('User authenticated, redirecting to dashboard from:', currentRoute);
          this.router.navigate(['/dashboard']);
        } 
        // If user is not authenticated and on root, redirect to login
        else if (!user && (currentRoute === '/' || currentRoute === '')) {
          console.log('User not authenticated, redirecting to login');
          this.router.navigate(['/login']);
        }
      }
    });
  }
}
